function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import BigNumber from "bignumber.js";
import sortBy from "lodash/sortBy";
import zipObject from "lodash/zipObject";
import { getFullScope } from "./getFullScope";
import { lookup } from "./lookup";
import { roundNumber } from "./roundNumber";
import { inferType } from "./inferType";
const DECIMAL_UNITS = {
  "0": "unit",
  "1": "ten",
  "2": "hundred",
  "3": "thousand",
  "6": "million",
  "9": "billion",
  "12": "trillion",
  "15": "quadrillion",
  "-1": "deci",
  "-2": "centi",
  "-3": "mili",
  "-6": "micro",
  "-9": "nano",
  "-12": "pico",
  "-15": "femto"
};
const INVERTED_DECIMAL_UNITS = zipObject(Object.values(DECIMAL_UNITS), Object.keys(DECIMAL_UNITS).map(key => parseInt(key, 10)));
export function numberToHuman(i18n, input, options) {
  const roundOptions = {
    roundMode: options.roundMode,
    precision: options.precision,
    significant: options.significant
  };
  let units;
  if (inferType(options.units) === "string") {
    const scope = options.units;
    units = lookup(i18n, scope);
    if (!units) {
      throw new Error(`The scope "${i18n.locale}${i18n.defaultSeparator}${getFullScope(i18n, scope, {})}" couldn't be found`);
    }
  } else {
    units = options.units;
  }
  let formattedNumber = roundNumber(new BigNumber(input), roundOptions);
  const unitExponents = units => sortBy(Object.keys(units).map(name => INVERTED_DECIMAL_UNITS[name]), numeric => numeric * -1);
  const calculateExponent = (num, units) => {
    const exponent = num.isZero() ? 0 : Math.floor(Math.log10(num.abs().toNumber()));
    return unitExponents(units).find(exp => exponent >= exp) || 0;
  };
  const determineUnit = (units, exponent) => {
    const expName = DECIMAL_UNITS[exponent.toString()];
    return units[expName] || "";
  };
  const exponent = calculateExponent(new BigNumber(formattedNumber), units);
  const unit = determineUnit(units, exponent);
  formattedNumber = roundNumber(new BigNumber(formattedNumber).div(Math.pow(10, exponent)), roundOptions);
  if (options.stripInsignificantZeros) {
    let _formattedNumber$spli = formattedNumber.split("."),
      _formattedNumber$spli2 = _slicedToArray(_formattedNumber$spli, 2),
      whole = _formattedNumber$spli2[0],
      significand = _formattedNumber$spli2[1];
    significand = (significand || "").replace(/0+$/, "");
    formattedNumber = whole;
    if (significand) {
      formattedNumber += `${options.separator}${significand}`;
    }
  }
  return options.format.replace("%n", formattedNumber || "0").replace("%u", unit).trim();
}